import React, { useCallback } from 'react'
import { variableStyle } from '../../../utils/styles'
import FormCustomTextInfos from './FormCustomTextInfos';
import { useTranslation } from 'react-i18next';
import ButtonCommon from '../../common/ButtonCommon';
import { App } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useStore } from '../../../store/store';
import TriggerArray from './TriggerArray';
import { useCreateCustomTextVariable, useUpdateVariableGroup } from '../../../hooks';
import { mutateInsertVariableInOrderArray } from '../../../utils/variableOrderArray';
import { convertToRaw } from 'draft-js';
import FormBoxEditorName from './FormBoxEditorName';
import { constructVariableIds, mutateHandleLinkedVariable } from '../../../utils/variableGroups';
import HideInFormSwitcher from '../../common/HideInFormSwitcher';
import DefaultValueBox from './DefaultValueBox';

const LeftPart = ({ box, validateFormAndRetrieveValues, form, setCreateItemType, variablesGroupedByContainerSelected }) => {
  const { t } = useTranslation()
  const { modal: modalApi } = App.useApp()
  const deleteVariableInDocument = useStore(({ deleteVariableInDocument }) => deleteVariableInDocument)
  const addVariable = useStore(({ addVariable }) => addVariable)
  const updateVariableGroup = useStore(({ updateVariableGroup }) => updateVariableGroup)

  const {
    mutate: createCustomTextVariable,
    isLoading
  } = useCreateCustomTextVariable();
  const {
    mutate: updateVariableGroupMutation,
    isLoading: isLoadingUpdateVariableGroup
  } = useUpdateVariableGroup({
    onSettled: () => {
      setCreateItemType()
    },
    onSuccess: (updatedVariableGroup, { variableKey, id }) => {
      updateVariableGroup(id,
        (variableGroup, draft) => {
          mutateHandleLinkedVariable({
            variableGroup,
            draft,
            variableIds: updatedVariableGroup.variable_ids,
            variableId: variableKey
          })
        })
    }
  });


  const onCreate = useCallback(async () => {
    try {
      const values = await validateFormAndRetrieveValues()
      const remarkRaw = JSON.stringify(convertToRaw(values.remark?.getCurrentContent()))

      createCustomTextVariable({ name: values.name, remarks: remarkRaw }, {
        onSuccess: (newVariable) => {
          addVariable(newVariable, (variables, variableKey, draft) => {
            variables[variableKey].remark = remarkRaw
            draft.boxVariableSelectedId = variableKey
            const hasVariableOrderArrayChanged = mutateInsertVariableInOrderArray(draft, variableKey)
            if (hasVariableOrderArrayChanged && box?.from?.id) {
              const idx = draft.variableOrderArray.findIndex(({ id }) => id === box?.from?.id)
              if (idx !== -1) {
                const element = draft.variableOrderArray[0];
                draft.variableOrderArray.splice(0, 1);
                draft.variableOrderArray.splice(box?.from.isAddedFromBottom ? idx : idx - 1,
                  0, element);
              }
            }
            if (values["linked-group"]) {
              const variableGroup = draft.variableGroups.find(
                (v) => v.id === values["linked-group"]
              )
              const variableIds = constructVariableIds({ variableGroup, variableId: variableKey })
              updateVariableGroupMutation({ id: variableGroup.id, variableIds, variableKey })
            } else {
              setCreateItemType()
            }
          }
          )
        }
      })
    } catch (errors) {
    }
  }, [validateFormAndRetrieveValues, createCustomTextVariable, addVariable, box?.from?.id, box?.from?.isAddedFromBottom, updateVariableGroupMutation, setCreateItemType])

  return (
    <div className='variable-editor__middle' style={variableStyle["middle"]}>
      {box.id === 'create-variable' && <div style={{
        display: 'flex',
        justifyContent: 'end',
        paddingBottom: 8
      }}>
        <ButtonCommon
          type="add"
          onClick={onCreate}
          loading={isLoading || isLoadingUpdateVariableGroup}
          disabled={isLoading || isLoadingUpdateVariableGroup}
        >
          {t('create')}
        </ButtonCommon>
      </div>}
      {box.id !== 'create-variable' && <>
        <div style={{ marginBottom: 16, fontWeight: "bold" }}>
          <HideInFormSwitcher boxId={box.id} variant='panel' />
        </div>
        <FormBoxEditorName box={box} variablesGroupedByContainerSelected={variablesGroupedByContainerSelected} />
      </>}
      <FormCustomTextInfos box={box} form={form} validateFormAndRetrieveValues={validateFormAndRetrieveValues} />
      {/* marginTop auto : ancré en bas de la carte, sa position ne bouge donc
          plus avec le nombre de valeurs prédéfinies. */}
      {box.id !== 'create-variable' && !box.isRecursive && <ButtonCommon
        type='delete'
        style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', flexShrink: 0 }}
        onClick={() => {
          modalApi.confirm({
            title: t('delete-custom-variable-text-modal', { name: box.name }),
            icon: <ExclamationCircleFilled />,
            okText: t('delete'),
            okType: "danger",
            cancelText: t('cancel'),
            onOk() {
              deleteVariableInDocument(box.id)
              return false;
            },
            onCancel() {
              return false;
            },
          });
        }}
      >
        {t('delete-custom-variable-text')}
      </ButtonCommon>}
    </div>
  )
}

const RightPart = ({ box, variablesGroupedByContainer }) => {
  return (
    <div className='variable-editor__middle' style={variableStyle["middle"]}>
      <DefaultValueBox box={box} />
      {box.id !== 'create-variable' && <TriggerArray box={box} variablesGroupedByContainer={variablesGroupedByContainer} />}
    </div>
  )
}

const FormCustomText = ({ box, form, validateFormAndRetrieveValues, formPart, setCreateItemType, variablesGroupedByContainer, variablesGroupedByContainerSelected }) => {
  return (
    <>
      {formPart === 'left' && <LeftPart setCreateItemType={setCreateItemType} box={box} validateFormAndRetrieveValues={validateFormAndRetrieveValues} form={form} variablesGroupedByContainerSelected={variablesGroupedByContainerSelected} />}
      {formPart === 'right' && <RightPart box={box} variablesGroupedByContainer={variablesGroupedByContainer} />}
    </>
  )
}

export default FormCustomText
